module.exports = __webpack_public_path__ + "static/img/gggggg_43.c84cd8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_43.png
// module id = So9j
// module chunks = 1